import React from 'react';
import { LayersIcon } from 'lucide-react';
import { footerCopy } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-blue-100 bg-white py-12 md:py-14" data-id="element-87" data-mp="3gg0zo4mhnzy6">
      <div className="mx-auto w-full max-w-4xl px-5 text-center md:px-8" data-id="element-88" data-mp="32onl753ftsa0">
        <p className="inline-flex items-center gap-2 text-base font-extrabold uppercase tracking-wider text-blue-600 md:text-lg md:tracking-widest" data-id="element-89" data-mp="36p6c8wxiaub5">
          <LayersIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-90" data-mp="3ufjuxwu7bgt2" />
          {footerCopy.name}
        </p>

        <p className="mx-auto mt-5 max-w-xl text-blue-900/75" data-id="element-91" data-mp="37xv6falryhh">{footerCopy.description}</p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-blue-900/75" data-id="element-92" data-mp="3le2icog05x94">
          {footerCopy.links.map(link => <li key={link.label} data-id="element-93" data-mp="29ynlrlrph7ej">
              <a href={link.href} className="transition-colors duration-150 ease-out hover:text-blue-600" data-id="element-94" data-mp="29xlz0k1buwgz">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-10 border-t border-blue-100 pt-6 text-sm text-blue-900/50" data-id="element-95" data-mp="3gah0br9yxf4s">
          {footerCopy.copyright}
        </p>
      </div>
    </footer>;
}